/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent:nb.view.List,
    view:{
        'class':'register-process clearfix'
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/view/register/List.js
// module id = 510
// module chunks = 6